import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export class SelectButtonTitle extends React.Component {
    render() {
        return (_jsx("div", { style: { marginLeft: 20 }, children: this.props.title }));
    }
}
//# sourceMappingURL=SelectButtonTitle.js.map